import { render } from "./OrdersIndex.vue?vue&type=template&id=664339d7"
import script from "./OrdersIndex.vue?vue&type=script&lang=js"
export * from "./OrdersIndex.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__